import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import Tilt from "react-parallax-tilt";
import { BookOpen, GraduationCap, ArrowRight } from "lucide-react";
import "./Teachers.css";

const Teachers = ({ darkMode }) => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeachers = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const educationalLevelId = localStorage.getItem('educationalLevelId');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/teacher/educational-level/${educationalLevelId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setTeachers(response.data.teachers || []);
      } catch (error) {
        console.error("Error fetching teachers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTeachers();
  }, []);

  const handleTeacherClick = (teacherId) => {
    localStorage.setItem("teacher_id", teacherId);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const cardVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    <div className={`edu-masr-wrapper ${darkMode ? 'dark-mode' : ''}`}>
      <main className="teachers-section">
        <div className="container">
          <header className="page-header">
            <motion.h1
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
            >
              نخبة معلمي <span>Edu Masr</span>
            </motion.h1>
            <p>اختر معلمك وابدأ رحلة النجاح الآن</p>
          </header>

          {loading ? (
            <div className="loader-grid">
              {[1, 2, 3, 4].map(n => <div key={n} className="skeleton-card"></div>)}
            </div>
          ) : (
            <motion.div
              className="teachers-grid"
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <AnimatePresence>
                {teachers.length > 0 ? (
                  teachers.map((teacher) => (
                    <motion.div key={teacher.id} variants={cardVariants}>
                      <Tilt tiltMaxAngleX={15} tiltMaxAngleY={15} scale={1.02} transitionSpeed={2000}>
                        <div className="modern-teacher-card">
                          <div className="image-wrapper">
                            <img 
                              src={`https://leader-acadmy.hwnix.com/storage/${teacher.image}`}
                              alt={teacher.name}
                            />
                            <div className="overlay-info">
                              <span className="badge">
                                <BookOpen size={14} /> {teacher.subject}
                              </span>
                            </div>
                          </div>

                          <div className="card-content">
                            <h3>{teacher.name}</h3>
                            
                            <div className="education-levels">
                              <GraduationCap size={16} className="icon-grad" />
                              <div className="levels-tags">
                                {/* ✅ Fixed: Safely check if it's an array before mapping */}
                                {Array.isArray(teacher.educational_level) && teacher.educational_level.length > 0 ? (
                                  teacher.educational_level.map((level, i) => (
                                    <span key={i} className="level-tag">{level}</span>
                                  ))
                                ) : typeof teacher.educational_level === 'string' ? (
                                  <span className="level-tag">{teacher.educational_level}</span>
                                ) : (
                                  <span className="level-tag">جميع المراحل</span>
                                )}
                              </div>
                            </div>

                            <a
                              href="/PricingCard"
                              className="main-btn"
                              onClick={() => handleTeacherClick(teacher.id)}
                            >
                              <span>تفاصيل الحجز</span>
                              <ArrowRight size={18} />
                            </a>
                          </div>
                        </div>
                      </Tilt>
                    </motion.div>
                  ))
                ) : (
                  <div className="no-data">عفواً، لا يوجد مدرسين متاحين حالياً.</div>
                )}
              </AnimatePresence>
            </motion.div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Teachers;